module.exports = __webpack_public_path__ + "ace52316602baf455d47b3597233b00f.png";